<template>
  <div v-if="!!userStore.currentTourDayItem" class="h-100">
    <v-loader v-if="activityDayItemResourcesStatus === 'loading'" />

    <form v-else id="tour-day-item-resource-update" class="d-flex flex-column justify-content-between h-100">
      <div>
        <template v-if="
          userStore.currentTourDayItem.type !== 'general_information' &&
          userStore.currentTourDayItem.type !== 'stage_information'
        ">
          <fieldset>
            <legend class="visually-hidden">{{ $t("tourBuilder.searchactivityDayItemResource") }}</legend>

            <div class="d-flex gap-16 mb-16">
              <div class="fw-medium">{{ $t("general.shared.supplier") }}:</div>
              <div>{{ supplierName }}</div>
            </div>

            <div v-if="isLuggageTransportSupplier" class="mb-16">
              <v-button size="sm" variant="outline-primary" @click="luggageCopyModalOpen = true">
                {{ $t("tourBuilder.copyLuggageToDays") }}
                <v-icon icon="luggage-cart" size="sm" space="ms-8" />
              </v-button>
            </div>

            <div class="resources-container form-outline">
              <div class="d-flex justify-content-between">
                <label class="label">
                  <span>{{ $t("general.shared.products") }}</span>
                </label>

                <label class="me-4 label">
                  <v-button class="btn-rates p-0 mx-4" variant="icon" v-if="supplier.type !== 'hotel'"
                    @click="openOffCanvas('the-supplier-details-rates-off-canvas')">
                    <v-icon class="px-0" icon="euro" />
                  </v-button>

                  <v-button class="btn-rates p-0 mx-4" variant="icon"
                    @click="openOffCanvas('the-supplier-details-offcanvas')">
                    <v-icon class="px-0" icon="pencil" />
                  </v-button>

                  <v-button class="btn-rates p-0 mx-4" variant="icon" @click="loadSupplierSelected"
                    v-if="supplier.type !== 'hotel'">
                    <v-icon class="px-0" icon="refresh" />
                  </v-button>
                </label>
              </div>

              <div class="form-control" v-if="supplier.type !== 'hotel'">
                <div v-if="resources.length === 0" class="text-muted text-center py-4">
                  {{ $t("general.shared.noProductsAdded") }}
                </div>
                <div v-else v-for="resource in resources" :key="resource.id"
                  class="resource-item d-flex justify-content-between align-items-center py-4">
                  <v-checkbox :id="`tour-day-item-create-resource-${resource.id}`" v-model="resource.check"
                    :for-key="`tour-day-item-create-resource-${resource.id}`" :label="resource.name"
                    class="form-check-inline me-32" label-class="ms-0" @click.prevent="setResource(resource)" />
                </div>
              </div>
              <div class="form-control" v-else>
                <div v-if="resources.length === 0" class="text-muted text-center py-4">
                  {{ $t("general.shared.noProductsAdded") }}
                </div>
                <div v-else v-for="resource in resources" :key="resource.id"
                  class="resource-item d-flex justify-content-between align-items-center py-4">
                  <div :id="`tour-day-item-create-resource-${resource.id}`" class="form-check-inline me-32">
                    {{ resource.name }}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <div class="search-separator-container mb-24 pb-24">
              <div class="separator-text-container mb-16" />
            </div>

            <div v-if="resourcesSelected.length > 0">
              <template v-for="(resource, index) in resourcesSelected" :key="index">
                <div :id="`accordionSupplierResource${resource.data.id}`" class="accordion border mb-16">
                  <div class="supplier-resource-details accordion-item mb-0">
                    <div :id="`headingSupplierResource${resource.data.id}`" class="accordion-header">
                      <button :aria-controls="`collapseSupplierResource${resource.data.id}`"
                        :data-bs-target="`#collapseSupplierResource${resource.data.id}`" aria-expanded="false"
                        class="accordion-button collapsed p-8" data-bs-toggle="collapse" type="button">
                        <span class="d-flex flex-column">
                          <span class="fw-medium pe-80">
                            {{ resource.data.name }}
                          </span>
                        </span>
                      </button>
                    </div>

                    <div :id="`collapseSupplierResource${resource.data.id}`"
                      :aria-labelledby="`headingSupplierResource${resource.data.id}`"
                      :data-bs-parent="`#accordionSupplierResource${resource.data.id}`"
                      class="accordion-collapse collapse">
                      <div class="accordion-body p-8">
                        <div v-for="(activityDayItemResource, indexItemResources) in resource.activityDayItemResources"
                          :key="`template-day-item-resource-${activityDayItemResource.id}`"
                          class="border rounded-xs p-12 gx-8 mb-8">
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="fw-medium text-sm">
                              {{ resource.data.name }}
                              <span v-if="resource.activityDayItemResources.length > 1" class="fw-normal text-xs">
                                (#{{ indexItemResources + 1 }})
                              </span>
                            </div>

                            <v-button size="sm" variant="icon"
                              @click="removeactivityDayItemResource(activityDayItemResource.id)">
                              <v-icon icon="trash" size="sm" />
                            </v-button>
                          </div>
                          <TheActivityDayItemDetailsResourceForm :agency="props.agency" :activity-id="props.templateId"
                            :activity-day-id="userStore.currentTourDayItem.activityDayId"
                            :activity-day-item-id="userStore.currentTourDayItem.id"
                            :activity-day-item-resource-id="activityDayItemResource.id"
                            :initial-observation="userStore.currentTourDayItem?.supplierObservation"
                            :nights="userStore.currentTourDayItem?.nights"
                            @emitReload="$emit('emitReloadTour')"
                            @updateHotelNights="handleUpdateHotelNights" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </fieldset>
        </template>
        <template v-else>
          <fieldset>
            <div class="selected d-center py-8">
              <div class="detail-title d-flex justify-content-between mb-20 align-items-center">
                <div class="fw-medium">{{ $t("resource.basicInformation") }}</div>

                <v-button class="btn-edit p-4" variant="icon" @click="openOffCanvas('the-resource-details-offcanvas')">
                  <v-icon icon="pencil" />
                </v-button>
              </div>
              <template v-for="(lang, index) in stageData?.translations" :key="index">
                <div class="text-sm d-flex py-4" v-if="currentLanguage === lang?.locale">
                  <span class="me-16 fw-medium">{{ $t("general.shared.title") }}: </span>
                  <span>{{ lang?.title }}</span>
                </div>
              </template>
              <div class="text-sm d-flex py-4">
                <span class="me-16 fw-medium">{{ $t("general.shared.location") }}: </span>
                <span>
                  {{ stageData?.city }}
                  <v-icon v-if="!!stageData?.destination" icon="arrow-right" size="xs" space="px-8" />
                  {{ stageData?.destination }}
                </span>
              </div>
              <div class="text-sm d-flex py-4" v-if="!!stageData?.types">
                <span class="me-16 fw-medium">{{ $t("general.shared.types") }}: </span>
                <span>{{ JSON.parse(stageData?.types)[0] }}</span>
              </div>
              <template v-for="(lang, index) in stageData?.translations" :key="index">
                <div class="text-sm d-flex py-4" v-if="currentLanguage === lang?.locale">
                  <span class="me-16 fw-medium">{{ $t("general.shared.description") }}: </span>
                  <span v-html="lang?.description" />
                </div>
              </template>
              <div class="search-separator-container mb-8">
                <div class="separator-text-container">
                  <span class="separator-text text-sm">{{ $t("general.shared.links") }}</span>
                </div>
              </div>
              <div v-if="stageData?.links" class="text-sm d-flex flex-column py-4">
                <span class="me-16 fw-medium">{{ $t("general.shared.links") }}: </span>
                <template v-for="url in JSON.parse(stageData?.links)" :key="url">
                  <a :href="url" class="resource-link btn-link" rel="noopener noreferrer" target="_blank">
                    {{ url }}
                  </a>
                </template>
              </div>
            </div>
          </fieldset>
        </template>
      </div>
    </form>

    <the-supplier-details-rates-off-canvas v-if="offCanvasToShow === 'the-supplier-details-rates-off-canvas'"
      :supplier-id="supplier.id" @closed="closeOffCanvas" />

    <the-supplier-create-offcanvas v-if="offCanvasToShow === 'the-supplier-create-offcanvas'" @closed="closeOffCanvas"
      @reload-suppliers="closeOffCanvas" @open-details="supplier = $event" />

    <the-supplier-details-offcanvas v-if="offCanvasToShow === 'the-supplier-details-offcanvas'" :is-archived="false"
      :is-double-off-canvas="false" :supplier-data="supplier" @closed="
        closeOffCanvas();
      loadSupplierSelected();
      " />

    <the-resource-details-offcanvas v-if="offCanvasToShow === 'the-resource-details-offcanvas'" :is-archived="false"
      :resource-data="stageData" tour-builder="tourBuilder" @closed="closeOffCanvas()"
      @reload-resources="closeOffCanvas" />

    <TheTemplateCopyLuggageToDaysModalV2
      v-if="luggageCopyModalOpen && userStore.currentTourDayItem"
      :agency="props.agency"
      :template-id="props.templateId"
      :source-tour-day-item="(userStore.currentTourDayItem as Record<string, unknown>)"
      @closed="luggageCopyModalOpen = false"
      @applied="onLuggageCopyApplied"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineComponent, getCurrentInstance, ref } from "vue";
import TheTemplateCopyLuggageToDaysModalV2 from "@/components/template/V2/TheTemplateCopyLuggageToDaysModalV2.vue";
import { VCheckbox } from "@uniqoders/form";
import { mapState } from "pinia";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import Supplier from "@/api/objects/Supplier";
import { useUserStore } from "@/stores/user";
import api from "@/api";
import SupplierResource from "@/api/objects/SupplierResource";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import TheSupplierDetailsRatesOffCanvas from "@/components/supplier/parts/TheSupplierDetailsRatesOffCanvas.vue";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";
import TheActivityDayItemDetailsResourceForm from "@/components/activity/TheActivityDayItemDetailsResourceForm.vue";
import TourDayItemResource from "@/api/objects/TourDayItemResource";
import TheSupplierDetailsOffcanvas from "@/components/supplier/TheSupplierDetailsOffcanvas.vue";
import TheSupplierCreateOffcanvas from "@/components/supplier/TheSupplierCreateOffcanvas.vue";
import TheResourceDetailsOffcanvas from "@/components/resource/TheResourceDetailsOffcanvas.vue";
import { useAppStore } from "@/stores/app";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import user from "@/lang/es/user";

const props = defineProps<{
  agency: string;
  templateId: number;
  status: string;
}>();

const emit = defineEmits<{
  (e: "closed"): void;
  (e: "emitReloadTour"): void;
  (e: "deletedItemResource"): void;
}>();

const { openOffCanvas, offCanvasToShow, closeOffCanvas } = useOffCanvasUtils();
const userStore = useUserStore();
const appStore = useAppStore();
const { t } = useI18n();
const instance = getCurrentInstance();
const $toast = instance?.appContext.config.globalProperties.$toast;
const $modal = instance?.appContext.config.globalProperties.$modal;

const resourceKey = ref(0);
const supplier = ref<Supplier>({} as Supplier);
const supplierName = ref("");
const resources = ref<SupplierResource[]>([]);
const resourcesMapped = ref<SupplierResource[]>([]);
const suppliersStatus = ref("loading");
const activityDayItemResourcesStatus = ref("loading");
const name = ref("");
const resourcesSelected = ref<Record<string, any>[]>([]);
const resourcesNextStep = ref(false);
const isDirty = ref(false);
const filters = ref({
  name: "",
  type: "",
});
const timers = ref({
  name: null as any,
});
const currentLanguage = ref(localStorage.getItem("language"));
const luggageCopyModalOpen = ref(false);

const isLuggageTransportSupplier = computed(() => {
  const supplierType = String(supplier.value?.type || "").toLowerCase();
  if (supplierType !== "luggage_transport") return false;
  const item = userStore.currentTourDayItem as Record<string, any> | null;
  return !!(item && (item.modelId ?? item.model?.id));
});

const onLuggageCopyApplied = async () => {
  const item = userStore.currentTourDayItem as Record<string, any> | null;
  emit("emitReloadTour");
  if (item?.id) {
    await userStore.setCurrentActivityDayItemV2({
      agency: props.agency,
      templateId: props.templateId,
      templateDayId: item.activityDayId,
      templateDayItemId: item.id,
    });
    await loadSupplierSelected();
    setTourDayItemData();
    mapResources();
  }
};

const stageData = computed(() => {
  return userStore.currentTourDayItem?.model;
});

onMounted(async () => {
  setTourDayItemData();
  await loadSupplierSelected();
});

const setTourDayItemData = () => {
  if (userStore.currentTourDayItem) {
    resourcesSelected.value = [];

    if (userStore.currentTourDayItem?.model) {
      if (userStore.currentTourDayItem.activityDayItemResources.length > 0) {
        userStore.currentTourDayItem.activityDayItemResources.forEach((searchResource: {
          supplierObservation: any; supplierResourceId: any; id: any; activityDayItemId: any;
        }) => {
          const resourceExist = checkExistResource(searchResource.supplierResourceId);

          if (resourceExist) {

            resourceExist.activityDayItemResources.push({
              id: searchResource.id,
              activityDayItemId: searchResource.activityDayItemId,
              supplierResourceId: searchResource.supplierResourceId,
            });
            resourceExist.quantity += 1; // Increment the quantity if needed
          } else {
            // Update to get the name from translations based on currentLanguage
            const translation = searchResource.supplierResource.translations.find(t => t.locale === currentLanguage.value);
            const name = translation ? translation.name : searchResource.supplierResource.name; // Fallback to default name

            resourcesSelected.value.push({
              data: {
                id: searchResource.supplierResourceId,
                name: name,
              },
              quantity: 1,
              activityDayItemResources: [
                {
                  id: searchResource.id,
                  activityDayItemId: searchResource.activityDayItemId,
                  supplierResourceId: searchResource.supplierResourceId,
                  supplierObservation: searchResource.supplierObservation
                },
              ],
            });
          }
        });
      } else {
        const resourceExist = checkExistResource(userStore.currentTourDayItem?.modelId);

        if (resourceExist) {
          resourceExist.activityDayItemResources.push(userStore.currentTourDayItem?.model);
          resourceExist.quantity += 1;
        } else {
          resourcesSelected.value.push({
            data: {
              id: userStore.currentTourDayItem?.model.id,
              name: userStore.currentTourDayItem?.model.name,
            },
            quantity: 1,
            activityDayItemResources: [userStore.currentTourDayItem?.model],
          });
        }
      }
    }

    activityDayItemResourcesStatus.value = "loaded";
  }
};

const mapResources = () => {
  resources.value = supplier.value?.resources?.map((resourceAux: any) => {
    const resourceExist = checkExistResource(resourceAux.id);
    resourceAux.check = !!resourceExist;
    return resourceAux;
  });
};

const loadSupplierSelected = async () => {
  if (userStore.currentTourDayItem) {
    try {
      const resource = userStore.currentTourDayItem;
      const supplierId = resource?.modelId;

      if (supplierId !== 0) {
        if(resource.type === 'stage_information' || resource.type === 'general_information') {
          supplier.value = await api.resource.retrieve(supplierId);         
        } else {
          supplier.value = await api.supplier.retrieve(supplierId);
        }
      }

      mapResources();

      supplierName.value = supplier.value?.name || "-";
    } catch (e: any) {
      console.error(e?.response?.data || e);
      $toast.error(e?.response?.data?.message || "Error loading supplier.");
    }
  }
};

const setResource = (resource: SupplierResource | any) => {
  if (!resource.check) {
    addResource(resource);
    resource.check = true;
  } else {
    deleteModalactivityDayItemResource(resource);
  }
};

const addResource = async (resource: SupplierResource | any) => {
  if (!userStore.currentTourDayItem) return;

  try {
    const data: Record<string, any> = {
      model_type: "supplier",
      model_id: resource.id,
    };
    const response: typeof activityDayItemResource = await api.activityService.createActivityDayItemResource(
      props.agency,
      props.templateId,
      userStore.currentTourDayItem?.activityDayId,
      Number(userStore.currentTourDayItem?.id),
      data
    );

    $toast.success(t("general.shared.savedChanges"));

    const item = {
      agency: props.agency,
      templateId: props.templateId,
      templateDayId: userStore.currentTourDayItem?.activityDayId,
      templateDayItemId: userStore.currentTourDayItem.id,
    };

    await userStore.setCurrentActivityDayItemV2(item);

    const activityDayItemResource: Record<string, any> = {
      id: response.id,
    };

    const resourceExist = checkExistResource(resource.id);

    if (resourceExist) {
      resourceExist.activityDayItemResources.push(activityDayItemResource);
      resourceExist.quantity += 1;
    } else {
      resourcesSelected.value.push({
        data: {
          id: resource.id,
          name: resource.name,
        },
        quantity: 1,
        activityDayItemResources: [activityDayItemResource],
      });
    }
  } catch (e: any) {
    console.error(e);
    $toast.error(e.response?.data?.message || "Error");
  }
};

const checkExistResource = (supplierResourceId: number | any): Record<string, any> | undefined => {
  return resourcesSelected.value.find((resourceAux: Record<string, any>) => resourceAux.data.id === supplierResourceId);
};

const deleteModalactivityDayItemResource = async (resource: any) => {
  if (!userStore.currentTourDayItem) return;

  const resourceExist = resourcesSelected.value.find((resourceAux) => resourceAux.data.id === resource.id);

  await $modal.delete({
    title: t('tourBuilder.deleteTourDayItemResourceTitle'),
    text: t('tourBuilder.deleteTourDayItemResourceText', {
      resource: resourceExist?.data.name,
    }),
    deleteButtonText: t("general.button.delete"),
    rightButtonClasses: "btn-tertiary",
    deleteButtonCallback: () => doDeleteAllactivityDayItemResources(resourceExist, resource),
  });
};

const doDeleteAllactivityDayItemResources = async (resource: any, resourceOriginal: any) => {
  if (!userStore.currentTourDayItem) return;

  for (const activityDayItemResource of resource.activityDayItemResources) {
    await removeactivityDayItemResource(activityDayItemResource.id, false);
  }

  resourceOriginal.check = false;

  const item = {
    agency: props.agency,
    templateId: props.templateId,
    templateDayId: userStore.currentTourDayItem.activityDayId,
    templateDayItemId: userStore.currentTourDayItem.id,
  };

  emit("deletedItemResource");

  await userStore.setCurrentActivityDayItemV2(item);

  if (userStore.currentTourDayItem.resources && userStore.currentTourDayItem.resources.length > 0) {
    setTourDayItemData();
  }
};

const removeactivityDayItemResource = async (activityDayItemResource: number, refreshCurrentTourDayItem = true) => {
  if (!userStore.currentTourDayItem) return;

  try {
    await api.activityService.deleteActivityDayItemResource(
      props.agency,
      props.templateId,
      userStore.currentTourDayItem?.activityDayId,
      Number(userStore.currentTourDayItem?.id),
      activityDayItemResource
    );

    $toast.success(t("general.shared.savedChanges"));

    if (refreshCurrentTourDayItem) {

      const item = {
        agency: props.agency,
        templateId: props.templateId,
        templateDayId: userStore.currentTourDayItem?.activityDayId,
        templateDayItemId: userStore.currentTourDayItem.id,
      };

      emit("deletedItemResource");

      await userStore.setCurrentActivityDayItemV2(item);

      await setTourDayItemData();
      mapResources();
    }
  } catch (e: any) {
    console.error(e);
    $toast.error(e.response?.data?.message || "An error occurred");
  }
};

const handleUpdateHotelNights = async (updatedHotel: any, newNights: number) => {
  try {
    // Find the day containing the updated hotel
    const allTourDays = userStore.currentTemplate?.tourDays || [];

    const currentDay = allTourDays.find((day: any) => {
      const items = day.activityDayItems || day.items || [];
      return items.some((item: any) => Number(item.id) === Number(updatedHotel.id));
    });

    if (!currentDay) return;

    const itemsInDay = currentDay.activityDayItems || currentDay.items || [];

    let updatedCount = 0;
    for (const item of itemsInDay) {
      if (
        (item.type || '').toLowerCase() === 'hotel' &&
        !item.disabled &&
        !item.isAutoGenerated
      ) {
        await api.activityService.updateDayItem(
          props.agency,
          props.templateId,
          Number(item.activityDayId || item.tourDayId),
          Number(item.id),
          { nights: Number(newNights) }
        );
        updatedCount++;
      }
    }

    emit('emitReloadTour');
  } catch (e: any) {
    console.error('Error updating hotel group nights:', e);
    $toast?.error(e.response?.data?.message || 'Error updating hotel group');
  }
};
</script>

<style lang="scss" scoped>
.accordion-item {
  background-color: transparent;
}

.accordion .accordion-item .accordion-button {
  font-size: 1rem;
}

.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
}

:deep(.form-control),
:deep(.vs__selected),
:deep(.vs__dropdown-option) {
  font-size: 0.9375rem !important;
}

:deep(.v-form-label),
:deep(.form-check-label) {
  font-size: 0.8125rem !important;
}
</style>
